import http from "./http";

export default {
  create(item) {
    console.log({ sending: item });
    return http.plainAxiosInstance.get(`/papers`, {
      paper: {
        event_time: item.event_time,
        champ_team_id: item.champ_team_id,
        match_id: item.match_id,
        squad_number_id: item.squad_number_id,
        kind: item.kind
      }
    });
  }
};
